<template>
  <div class="companyBox">
    <navigation></navigation>
    <div class="homeBG">
    </div>
    <div class="contenter">
      <ul class="conul"  style="padding: 0;" >
        <li>
          <p><img border="0" src="../img/1635580732903508.jpg" title="中央企业先进基层党组织"></p>
          <div>
            中央企业先进基层党组织
          </div>
        </li>
        <li>
          <p><img border="0" src="../img/1635580732870025.jpg" title="中央企业抗击新冠肺炎疫情先进集体"></p>
          <div>
            中央企业抗击新冠肺炎疫情先进集体
          </div>
        </li>
        <li>
          <p><img border="0" src="../img/1635580732781718.jpg" title="全省抗击新冠肺炎疫情先进集体"></p>
          <div>
            全省抗击新冠肺炎疫情先进集体
          </div>
        </li>
        <li>
          <p><img border="0" src="../img/1635580732636105.jpg" title="全国模范职工之家"></p>
          <div>
            全国模范职工之家
          </div>
        </li>
        <li>
          <p><img border="0" src="../img/1635580732481072.jpg" title="国有重点企业管理标杆创建行动"></p>
          <div>
            国有重点企业管理标杆创建行动
          </div>
        </li>
        <li>
          <p><img border="0" src="../img/1635580732247712.jpg" title="高新技术企业"></p>
          <div>
            高新技术企业
          </div>
        </li>
        <li>
          <p><img border="0" src="../img/1635580732200532.jpg" title="江苏省二恶英烟气分解除尘工程技术研究中心"></p>
          <div>
            江苏省二恶英烟气分解除尘工程技术研究中心
          </div>
        </li>

        <li>
          <p><img border="0" src="../img/rongyu1.jpg" title="高温过滤领域袋式除尘技术先进应用示范单位"></p>
          <div>
            高温过滤领域袋式除尘技术先进应用示范单位
          </div>
        </li>
        <li>
          <p><img border="0" src="../img/rongyu2.jpg" title="全国纺织行业实施卓越绩效模式先进企业"></p>
          <div>
            全国纺织行业实施卓越绩效模式先进企业
          </div>
        </li>
        <li>
          <p><img border="0" src="../img/1635580732110718.jpg" title="江苏省认定企业技术中心"></p>
          <div>
            江苏省认定企业技术中心
          </div>
        </li>
        <li>
          <p><img border="0" src="../img/1635580732015928.jpg" title="江苏省重要储备物资定点生产企业"></p>
          <div>
            江苏省重要储备物资定点生产企业
          </div>
        </li>
        <li>
          <p><img border="0" src="../img/1635548774922159.jpg" title="全国文明单位"></p>
          <div>
            全国文明单位
          </div>
        </li>
      </ul>
    </div>

    <dibu></dibu>
  </div>
</template>

<script>
import navigation from '@/views/navigation.vue'
import dibu from './dibu.vue';
export default {
  name: 'CompanyProfile',
  components: {
    navigation,
    dibu
  }
}

</script>
<style lang="scss" scoped>
.companyBox {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
   position: relative;

  .homeBG {
    width: 100%;
    height: 400px;
    background-image: url('../img/wzdh.png');
    background-size: 100% 100%;
  }

  .contenter {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    box-sizing: border-box;
    background-size: 100%;
    padding: 0 15px;
  }
  
  .conul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start; /* 改为flex-start避免空间浪费 */
    margin-top: 30px;
    gap: 20px; /* 使用gap替代margin */

    li {
      width: calc(50% - 10px); /* 考虑gap的影响 */
      margin-bottom: 30px;
      box-sizing: border-box;
      text-align: center;
      list-style: none;

      img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        background-repeat: no-repeat;
        border-radius: 8px; /* 添加圆角 */
      }

      div {
        margin-top: 15px;
        font-size: 16px;
        color: #333;
        font-weight: 500;
        line-height: 1.4;
        word-break: break-all; /* 允许长单词换行 */
        hyphens: auto; /* 自动连字符 */
      }
    }
  }
  
  .conul li div {
    width: 100%;
    min-height: 60px; /* 改为最小高度 */
    height: auto; /* 高度自适应 */
    margin: 0 auto;
    text-align: center;
    background: white;
    line-height: 1.4;
    box-sizing: border-box;
    padding: 15px 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px; /* 添加圆角 */
    display: flex;
    align-items: center;
    justify-content: center;
    word-wrap: break-word; /* 长文本换行 */
    white-space: normal; /* 改为normal允许换行 */
    text-overflow: clip; /* 移除省略号 */
    overflow: visible; /* 改为visible显示全部内容 */
  }
}

/* 平板适配 */
@media (min-width: 768px) and (max-width: 1024px) {
  .companyBox {
    .homeBG {
      height: 500px;
    }
    
    .contenter {
      width: 95%;
      padding: 0 20px;
    }
    
    .conul {
      gap: 25px;
      
      li {
        width: calc(33.333% - 17px); /* 三列布局考虑gap */
        
        img {
          height: 220px;
        }
        
        div {
          font-size: 17px;
        }
      }
    }
    
    .conul li div {
      min-height: 65px;
      padding: 18px 15px;
    }
  }
}

/* 桌面端 */
@media (min-width: 1025px) {
  .companyBox {
    .homeBG {
      height: 800px;
    }
    
    .contenter {
      width: 1400px;
      padding: 0;
    }
    
    .conul {
      gap: 30px;
      margin-top: 50px;
      
      li {
        width: calc(33.333% - 20px); /* 三列布局考虑gap */
        
        img {
          height: 270px;
        }
        
        div {
          font-size: 18px;
        }
      }
    }
    
    .conul li div {
      min-height: 70px;
      padding: 20px 15px;
    }
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .companyBox {
    .homeBG {
      height: 300px;
    }
    
    .contenter {
      padding: 0 10px;
    }
    
    .conul {
      gap: 15px;
      margin-top: 20px;
      
      li {
        width: calc(50% - 7.5px);
        margin-bottom: 20px;
        
        img {
          height: 160px;
        }
        
        div {
          font-size: 14px;
          margin-top: 10px;
        }
      }
    }
    
    .conul li div {
      min-height: 50px;
      padding: 12px 8px;
      line-height: 1.3;
    }
  }
}
</style>